import Cookies from 'js-cookie'
const TokenKey = 'ols-open-api-'

export function getToken (name) {
  const token = Cookies.get(TokenKey + name)
  if (token) {
    return JSON.parse(token)
  } else {
    return null
  }
}

export function setToken (name, token, needStringify = false) {
  const stringified = needStringify ? JSON.stringify(token) : token
  return Cookies.set(TokenKey + name, stringified, { expires: 59 })
}

export function removeToken (name) {
  Cookies.remove(TokenKey + name)
}
